import Team from "@/types/Team";

const teams: Team[] = [
  {
    id: "juniorky",
    barva: "#8D566E",
    jmeno: "Juniorky",
    trener: "Klaudie Palkosková, Lucia Stopková",
    komunikace: {
      instagram: "https://www.instagram.com/teamkometajunior/",
      facebook:
        "https://www.facebook.com/profile.php?id=61555397120486&sk=about",
    },
    obrazekUpoutavky: "/assets/teams/juniorky/team-juniorky-page.jpg",
    obrazekObsahu: "/assets/teams/juniorky/team-juniorky-page.jpg",
    obsah:
      '<div class="row">\n' +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/juniorky/juniorky-1.jpg" class="img-fluid kometa-image-rounded" alt="Juniorky" />\n' +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <p class="text-justify">Tým se skládá z dívek ve věku 14-18 let, bruslí spolu od roku 2017. Značná část bruslařek se stále věnuje nebo věnovala sólovému krasobruslení, což je velkou předností tohoto týmu.</p>\n' +
      '            <p class="text-justify">Tréninky juniorského týmu probíhají 3-4x týdně na zimním stadionu Hasa. Nezbytnou součástí tréninků je suchá příprava, která probíhá vždy před tréninkem na ledě. Suchá příprava je zaměřená na taneční průpravu, protahování, posilování a fyzio cvičení. V rámci suché přípravy probíhá i nácvik závodních jízd.</p>\n' +
      '            <p class="text-justify">Letošní sezóna bude druhou společnou sezónou v juniorské kategorii. Děvčata velmi dobře zvládla přechod do starší kategorie a navázala tak na výborné výsledky z kategorie žaček.</p>\n' +
      '            <p class="text-justify">Tým se stal vítězem jak českého poháru 2024/2025, tak vítězem MČR 2025. Úspěšné byly i mezinárodní starty, které přinesly nejen cenné zkušenosti, ale i pěkná umístění. V rámci série závodů Challenger series se náš mladý tým zúčastnil soutěže Mozart cup, kde v konkurenci 18 týmů z 15 států obsadil fantastické 7. místo (6.místo přitom uniklo jen o 0,27 bodu). Další mezinárodní soutěží byl Budapest cup, ze kterého si děvčata přivezla bronzové medaile.</p>\n' +
      '            <p><a class="btn kometa-btn kometa-juniorky-bg" href="/pridej-se-k-nam">Přidej se k juniorkám</a></p>' +
      "          </div>\n" +
      "        </div>\n" +
      "\n" +
      '        <div class="row">\n' +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <h3 class="h3">Naše historie a úspěchy</h3>\n' +
      '            <p class="text-justify fst-italic">2017/2018–2019/2020 kategorie žačky mladší (6-13 let)</p>\n' +
      '            <p class="text-justify">Po prvním roce, kdy jsme se postupně učily základní formace a získávaly první zkušenosti se synchro závody, se začaly dostavovat výsledky naší práce. V následujících dvou závodních sezonách se nám dařilo a obsazovaly jsme stupně vítězů jak na domácích, tak zahraničních závodech. </p>\n' +
      '            <p class="text-justify">Výsledky mezinárodních soutěží:</p>\n' +
      "<ul>" +
      '            <li class="text-justify">Amadé cup 2019 2.místo</li>\n' +
      '            <li class="text-justify">Cup of Dresden 2020 1. místo</li>\n' +
      '            <li class="text-justify">Zagreb Snowflakes Trophy 2020 3. místo</li>\n' +
      "</ul>" +
      '            <p class="text-justify fst-italic pt-3">2020-2021 – covidová pauza</p>\n' +
      '            <p class="text-justify">Tréninky probíhaly převážně na suchu v on-line podobě.</p>\n' +
      '            <p class="text-justify fst-italic pt-3">2021/2022-2023/2024 kategorie advanced novice (10-16 let)</p>\n' +
      '            <p class="text-justify">V této kategorii jsme vyhráli 2x MČR a cenné kovy jsme sbíraly i na mezinárodních soutěžích.</p>\n' +
      '            <p class="text-justify">Výsledky mezinárodních soutěží:</p>\n' +
      "<ul>" +
      '            <li class="text-justify">Santa Claus cup 2022, 2023 1. místo</li>\n' +
      '            <li class="text-justify">Mozart cup 2023 2. místo, 2024 4. místo</li>\n' +
      '            <li class="text-justify">Dresden cup 2023, 2024 1. místo</li>\n' +
      "</ul>" +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/juniorky/juniorky-2.jpg" class="img-fluid kometa-image-rounded" alt="Juniorky" />\n' +
      "          </div>\n" +
      "        </div>",
    clenky: [
      {
        id: 1,
        jmeno: "Veronika Buzková „C“",
        obrazek: "/assets/teams/juniorky/clenky/veronika-buzkova.jpg",
        od: "2017",
        popis: "",
      },
      {
        id: 2,
        jmeno: "Viktoria Illina „C“",
        obrazek: "/assets/teams/juniorky/clenky/viktoria-illina.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 3,
        jmeno: "Agneta Rabová",
        obrazek: "/assets/teams/juniorky/clenky/agneta-rabova.jpg",
        od: "2018",
        popis: "",
      },
      {
        id: 4,
        jmeno: "Sophie Müllerová",
        obrazek: "/assets/teams/juniorky/clenky/sophie-mullerova.jpg",
        od: "2017",
        popis: "",
      },
      {
        id: 5,
        jmeno: "Edita Luisa Gabrielová",
        obrazek: "/assets/teams/juniorky/clenky/edita-luisa-gabrielova.jpg",
        od: "2018",
        popis: "",
      },
      {
        id: 6,
        jmeno: "Anika Rabová",
        obrazek: "/assets/teams/juniorky/clenky/anika-rabova.jpg",
        od: "2017",
        popis: "",
      },
      {
        id: 7,
        jmeno: "Adéla Nicol Gabrielová",
        obrazek: "/assets/teams/juniorky/clenky/adela-nicol-gabrielova.jpg",
        od: "2018",
        popis: "",
      },
      {
        id: 8,
        jmeno: "Klaudie Udržalová",
        obrazek: "/assets/teams/juniorky/clenky/klaudie-udrzalova.jpg",
        od: "2020",
        popis: "",
      },
      {
        id: 9,
        jmeno: "Alžběta Fairaisl",
        obrazek: "/assets/teams/juniorky/clenky/alzbeta-fairaisl.jpg",
        od: "2017",
        popis: "",
      },
      {
        id: 10,
        jmeno: "Tereza Vršecká",
        obrazek: "/assets/teams/juniorky/clenky/tereza-vrsecka.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 11,
        jmeno: "Zoe Prášilová",
        obrazek: "/assets/teams/juniorky/clenky/zoe-prasilova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 12,
        jmeno: "Alyssa Balaria",
        obrazek: "/assets/teams/juniorky/clenky/alyssa-balaria.jpeg",
        od: "2022",
        popis: "",
      },
      {
        id: 13,
        jmeno: "Ema Vindeman",
        obrazek: "/assets/teams/juniorky/clenky/ema-vindeman.jpeg",
        od: "2022",
        popis: "",
      },
      {
        id: 14,
        jmeno: "Natálie Šlégrová",
        obrazek: "/assets/teams/juniorky/clenky/natalie-sleglova.jpeg",
        od: "2022",
        popis: "",
      },
      {
        id: 15,
        jmeno: "Sofia Bogdanova",
        obrazek: "/assets/teams/juniorky/clenky/sofia-bogdanova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 16,
        jmeno: "Tereza Malevičová",
        obrazek: "/assets/teams/juniorky/clenky/tereza-malevicova.jpeg",
        od: "2022",
        popis: "",
      },
      {
        id: 17,
        jmeno: "Sara Zemková",
        obrazek: "/assets/teams/juniorky/clenky/sara-zemkova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 18,
        jmeno: "Nikol Luxová",
        obrazek: "/assets/teams/juniorky/clenky/nicol-luxova.jpg",
        od: "2015",
        popis: "",
      },
      {
        id: 19,
        jmeno: "Mia Uhliarik",
        obrazek: "/assets/teams/juniorky/clenky/mia-uhliarik.jpeg",
        od: "2018",
        popis: "",
      },
    ],
  },
  {
    id: "mixed-age",
    barva: "#634a79",
    jmeno: "Mixed Age",
    trener: "Lucia Stopková",
    komunikace: {
      instagram: "https://www.instagram.com/teamkometajunior/",
      facebook:
        "https://www.facebook.com/profile.php?id=61555397120486&sk=about",
    },
    obrazekUpoutavky: "/assets/teams/mixed-age/team-mixed-age-page.jpg",
    obrazekObsahu: "/assets/teams/mixed-age/team-mixed-age-page.jpg",
    obsah:
      '<div class="row">\n' +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/mixed-age/mixed-age-1.jpg" class="kometa-image-rounded img-fluid" alt="Mixed Age" />\n' +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <p class="text-justify">Kometa Mixed Age je tým synchronizovaného bruslení tvořený bruslařema ve věku průměrně 14 až 22 let, které spojuje láska k bruslení, týmový duch a touha dál růst – bez ohledu na věk či studijní povinnosti.</p>\n' +
      '            <p class="text-justify">Loňská sezóna byla již naše třetí v juniorské kategorii, a konečně jsme se mohli opět vrátit na závodní led, a to hned na dvou zahraničních závodech a dvou domácích. První domácí závod v Jihlavě byl z hlediska výsledku náš nejúspěšnější, kdy při plné účasti českých týmů jsme si odvezli zlatou medaili.</p>\n' +
      '            <p class="text-justify">Za juniory jsme poprvé závodili před třemi lety. V naší první juniorské sezóně jsme s krátkým programem na téma armády a volnou jízdou v duchu mumie získali mnoho cenných zkušeností i z velkých zahraničních závodů.</p>\n' +
      '            <p class="text-justify">V druhé sezóně jsme se opřeli o naši týmovou sílu a disciplínu a trénovali v nelehkých podmínkách covidových opatření. Byl to rok plný netradičních zážitků.</p>\n' +
      '            <p class="text-justify">Nyní se už těšíme na výzvy nadcházející sezóny!</p>\n' +
      '            <p><a class="btn kometa-btn kometa-mixed-age-bg" href="/pridej-se-k-nam">Přidej se k Mixed Age</a></p>' +
      "          </div>\n" +
      "        </div>\n" +
      "\n" +
      '        <div class="row">\n' +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <h3 class="h3">Naše historie a úspěchy</h3>\n' +
      '            <p class="text-justify">V prvních dvou závodních sezónách jsme startovali v kategorii mladších žáků. V této kategorii jsme se stali mistry ČR a přivezli jsme několik medailí z mezinárodních závodů.</p>\n' +
      '            <p class="text-justify">Další tři sezóny jsme soutěžili v kategorii žáků. V roce 2017 jsme se stali vícemistry ČR a v roce 2018 jsme na mistrovství obsadili třetí místo. V sezóně 2019 jsme postoupili do kategorie advanced novice, ve které jsme započali soutěžení v počtu 16 bruslařů, a tak se o krok přiblížili k juniorské kategorii. A byl to začátek úspěšný. Vyhráli jsme mistroství ČR a těšili jsme se i z úspěchů ze zahraničních závodů.</p>\n' +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/mixed-age/mixed-age-2.jpg" class="img-fluid kometa-image-rounded" alt="Mixed age" />\n' +
      "          </div>\n" +
      "        </div>",
    clenky: [
      {
        id: 1,
        jmeno: "Kitty Nedvědová „C“",
        obrazek: "/assets/teams/mixed-age/clenky/Kitty-Nedvedova.jpeg",
        od: "2014",
        popis: "",
      },
      {
        id: 2,
        jmeno: "Magda Hrubá „C“",
        obrazek: "/assets/teams/mixed-age/clenky/Magda-Hruba.jpeg",
        od: "2010",
        popis: "",
      },
      {
        id: 3,
        jmeno: "Kateřina Janovská (Kačka)",
        obrazek: "/assets/teams/mixed-age/clenky/Katerina-Janovska.jpg",
        od: "2013",
        popis: "",
      },
      {
        id: 4,
        jmeno: "Aneta Müllerová",
        obrazek: "/assets/teams/mixed-age/clenky/Aneta-Mulerova.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 5,
        jmeno: "Sára Zemková",
        obrazek: "/assets/teams/mixed-age/clenky/Sara-Zemkova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 6,
        jmeno: "Matylda Prušinovská",
        obrazek: "/assets/teams/mixed-age/clenky/matylda-prusinovska.jpeg",
        od: "2018",
        popis: "",
      },
      {
        id: 7,
        jmeno: "Veronika Buzková",
        obrazek: "/assets/teams/mixed-age/clenky/veronika-buzkova.jpg",
        od: "2017",
        popis: "",
      },
      {
        id: 8,
        jmeno: "Hedvika Fundová",
        obrazek: "/assets/teams/mixed-age/clenky/hedvika-fundova.jpeg",
        od: "2013",
        popis: "",
      },
      {
        id: 9,
        jmeno: "Vilma Martínková",
        obrazek: "/assets/teams/mixed-age/clenky/vilma-martinkova.jpeg",
        od: "2013",
        popis: "",
      },
      {
        id: 10,
        jmeno: "Alžběta Fairaisl",
        obrazek: "/assets/teams/mixed-age/clenky/alzbeta-fairaisel.jpeg",
        od: "2017",
        popis: "",
      },
      {
        id: 11,
        jmeno: "Nicole Luxová",
        obrazek: "/assets/teams/mixed-age/clenky/nicole-luxova.jpeg",
        od: "2015",
        popis: "",
      },
      {
        id: 12,
        jmeno: "Klaudie Udržalová",
        obrazek: "/assets/teams/mixed-age/clenky/klaudie-udrzalova.jpg",
        od: "2020",
        popis: "",
      },
      {
        id: 13,
        jmeno: "Vojtěch Müller",
        obrazek: "/assets/teams/mixed-age/clenky/Vojtech-Muler.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 14,
        jmeno: "Dominika Jotovová",
        obrazek: "/assets/teams/mixed-age/clenky/Dominika-Jotovova.jpeg",
        od: "2021",
        popis: "",
      },
    ],
  },
  {
    id: "zacky",
    barva: "#D2563E",
    jmeno: "Žačky",
    trener: "Klaudie Palkosková, Aneta Müllerová",
    komunikace: {
      instagram: "https://www.instagram.com/teamkometa_novice/",
      facebook:
        "https://www.facebook.com/profile.php?id=61555397120486&sk=about",
    },
    obrazekUpoutavky: "/assets/teams/zacky/team-zacky-page.jpg",
    obrazekObsahu: "/assets/teams/zacky/team-zacky-page.jpg",
    obsah:
      '<div class="row">\n' +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/zacky/zacky-1.jpg" class="img-fluid kometa-image-rounded" alt="Žačky" />\n' +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <p class="text-justify">Tým vznikl na jaře roku 2020. V týmu bruslí děvčata ve věku 10 až 14 let. Tréninky žaček jsou rozdělené na tréninky techniky bruslení a na synchro tréninky (děvčata ze sóla absolvují pouze synchro tréninky). Tréninky probíhají 3 x týdně na zimním stadionu Hasa, synchro trénink probíhá na Ice aréna Kateřinky. Součástí tréninků je i suchá příprava zaměřená na protahování, posilování a nácvik závodních jízdy.</p>\n' +
      '            <p class="text-justify">Letošní sezóna bude druhou společnou sezónou v kategorii žačky. Děvčata velmi dobře zvládla přechod do starší kategorie a navázala tak na výborné výsledky z kategorie mladších žaček.</p>\n' +
      '            <p class="text-justify">Tým se v uplynulé závodní sezóně stal vítězem MČR 2025, v českém poháru se umístil na druhém místě. Kromě MČR se žačky zúčastnily dalších pěti soutěžích, z toho třech mezinárodních. Na všech těchto soutěžích se tým umístil na stupních vítězů. Asi nejvíce si ceníme zlaté medaile z Budapest Cupu kde startovalo dvanáct týmů z šesti států.</p>\n' +
      '            <p class="text-justify">Výsledky 2024/2025</p>\n' +
      "            <ul>\n" +
      '            <li class="text-justify">Vysočina cup 1. místo</li>\n' +
      '            <li class="text-justify">Santa Claus Cup 2. místo/li>\n' +
      '            <li class="text-justify">Amadé Cup 3. místo/li>\n' +
      '            <li class="text-justify">MČR 1. místo/li>\n' +
      '            <li class="text-justify">Budapest Cup 1.místo</li>\n' +
      '            <li class="text-justify">Bakus cup 1.místo</li>\n' +
      "            </ul>\n" +
      '            <p><a class="mt-5 btn kometa-btn kometa-zacky-bg" href="/pridej-se-k-nam">Přidej se k žačkám</a></p>' +
      "          </div>\n" +
      "        </div>\n" +
      "\n" +
      '        <div class="row">\n' +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <h3 class="h3">Naše historie</h3>\n' +
      '            <p class="text-justify fst-italic">2020/2021-2023/2024 mladší žačky (6-13 let)</p>\n' +
      '            <p class="text-justify">Tým vznikl na jaře roku 2020. Bohužel po pár měsících společné práce se díky „covidovým“ opatřením tréninky přesunuly jen do virtuální podoby. Od května 2021 se začalo naplno trénovat.</p>\n' +
      '            <p class="text-justify">Svou závodní premiéru děvčata absolvovala na mezinárodní soutěži Óbuda Cup 2021, který se konal v Budapešti. Z Maďarska si tým odvezl bramborovou medaili, a první cenné závodní zkušenosti. Kromě této soutěže děvčata absolvovala další tři starty a závod od závodu si zlepšovala své osobní bodové maximum. Na únorovém MČR 2022 děvčata obsadila v konkurenci šesti týmů úžasné druhé místo.</p>\n' +
      '            <p class="text-justify">Tým se stal mistrem ČR pro rok 2023, v roce 2024 se bohužel MČR nekonalo. I na ostatních soutěžích se týmu v těchto závodních sezónách dařilo.</p>\n' +
      '            <p class="text-justify">Výsledky mezinárodních soutěží:</p>\n' +
      "            <ul>\n" +
      '            <li class="text-justify">Óbuda cup 2021 4. místo</li>\n' +
      '            <li class="text-justify">Jihlavský Ježek 2022 4. místo</li>\n' +
      '            <li class="text-justify">Santa Claus cup 2022 3. místo, 2023, 2024 1. místo</li>\n' +
      '            <li class="text-justify">Dresden cup 2023 2.místo, 2024 1.místo</li>\n' +
      '            <li class="text-justify">Amadé cup 2023 3. místo, 2024 1. místo, 2025 3. místo</li>\n' +
      '            <li class="text-justify">Swiss cup 2023 1. místo</li>\n' +
      '            <li class="text-justify">Hevelis cup 2024 1. místo</li>\n' +
      '            <li class="text-justify">Bavaria cup 2024 1. místo</li>\n' +
      '            <li class="text-justify pb-5">Budapest cup 2025 1. místo</li>\n' +
      "            </ul>\n" +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/zacky/zacky-2.jpg" class="img-fluid kometa-image-rounded" alt="Žačky" />\n' +
      "          </div>\n" +
      "        </div>",
    clenky: [
      {
        id: 1,
        jmeno: "Julieta Wellartová",
        obrazek: "/assets/teams/zacky/clenky/julieta-wellartova.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 2,
        jmeno: "Josefina Fanthorpe",
        obrazek: "/assets/teams/zacky/clenky/josefina-fanthorpe.jpg",
        od: "2020",
        popis: "",
      },
      {
        id: 3,
        jmeno: "Olívie Fanthorpe",
        obrazek: "/assets/teams/zacky/clenky/olivie-fanthorpe.jpg",
        od: "2020",
        popis: "",
      },
      {
        id: 4,
        jmeno: "Sofia Bogdanova",
        obrazek: "/assets/teams/zacky/clenky/sofia-bogdanova.jpg",
        od: "2020",
        popis: "",
      },
      {
        id: 5,
        jmeno: "Daniela Galambošová",
        obrazek: "/assets/teams/zacky/clenky/daniela-galambosova.jpg",
        od: "2020",
        popis: "",
      },
      {
        id: 6,
        jmeno: "Sandra Nováková",
        obrazek: "/assets/teams/zacky/clenky/sandra-novakova.jpg",
        od: "2018",
        popis: "",
      },
      {
        id: 7,
        jmeno: "Aneta Žáčková",
        obrazek: "/assets/teams/zacky/clenky/aneta-zackova.jpg",
        od: "2018",
        popis: "",
      },
      {
        id: 8,
        jmeno: "Eliška Bělská",
        obrazek: "/assets/teams/zacky/clenky/eliska-belska.jpg",
        od: "2018",
        popis: "",
      },
      {
        id: 9,
        jmeno: "Kamila Slobodová",
        obrazek: "/assets/teams/zacky/clenky/kamila-slobodova.jpg",
        od: "2017",
        popis: "",
      },
      {
        id: 10,
        jmeno: "Alžběta Vychodilová",
        obrazek: "/assets/teams/zacky/clenky/alzbeta-vychodilova.jpg",
        od: "2020",
        popis: "",
      },
      {
        id: 11,
        jmeno: "Valentina Wellertová",
        obrazek: "/assets/teams/zacky/clenky/valentina-wellertova.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 12,
        jmeno: "Natálie Matkovská",
        obrazek: "/assets/teams/zacky/clenky/natalie-matkovska.jpg",
        od: "2018",
        popis: "",
      },
      {
        id: 13,
        jmeno: "Mia Uhliarik",
        obrazek: "/assets/teams/zacky/clenky/mia-uhliarik.jpeg",
        od: "2020",
        popis: "",
      },
      {
        id: 14,
        jmeno: "Aya Mrkvičková",
        obrazek: "/assets/teams/zacky/clenky/aya-mrkvickova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 15,
        jmeno: "Valentine Vincent",
        obrazek: "/assets/teams/zacky/clenky/valentine-vincent.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 16,
        jmeno: "Hana Smolařová",
        obrazek: "/assets/teams/zacky/clenky/hana-smolarova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 17,
        jmeno: "Emma Skavroňová",
        obrazek: "/assets/teams/zacky/clenky/emma-skavronova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 18,
        jmeno: "Iva Matelová",
        obrazek: "/assets/teams/zacky/clenky/iva-matelova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 19,
        jmeno: "Magdalena Moudrá",
        obrazek: "/assets/teams/zacky/clenky/magdalena-moudra.jpg",
        od: "2019",
        popis: "",
      },
      {
        id: 20,
        jmeno: "Tereza Kalušová",
        obrazek: "/assets/teams/zacky/clenky/magdalena-moudra.jpg",
        od: "2025",
        popis: "",
      },
    ],
  },
  {
    id: "mladsi-zacky",
    barva: "#E29C47",
    jmeno: "Mladší žačky",
    trener: "Jana Ficová, Kateřina Janovská",
    komunikace: {
      facebook:
        "https://www.facebook.com/profile.php?id=61555397120486&sk=about",
    },
    obrazekUpoutavky: "/assets/teams/mladsi-zacky/team-mladsi-zacky-page.jpg",
    obrazekObsahu: "/assets/teams/mladsi-zacky/team-mladsi-zacky-page.jpg",
    obsah:
      '<div class="row">\n' +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/mladsi-zacky/mladsi-zacky-1.jpg" class="img-fluid kometa-image-rounded" alt="Mladší žačky" />\n' +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <p class="text-justify">Náš nejmladší tým tvoří holky a kluci ve věku 8-12 let. Letošní sezóna bude pro tento tým druhou společnou sezónou v kategorii mladších žáků/žaček.</p>\n' +
      '            <p class="text-justify">Vedle synchro tréninků se s dětmi stále věnujeme hodně technice bruslení. (Děvčata a chlapci ze sóla absolvují pouze synchro tréninky.)</p>\n' +
      '            <p class="text-justify">Tréninky techniky bruslení probíhají 3x týdně na zimních stadionech Hasa a Ice Aréna Kateřinky. Každý trénink na ledě doprovází suchá příprava, která je jeho nedílnou součástí. Věnujeme se při ní základní pohybové průpravě a kondičnímu cvičení.</p>\n' +
      '            <p class="text-justify">Synchro trénink pak probíhá na zimním stadionu Icerink. Zde se na ledě i v rámci suché přípravy věnujeme hlavně nácviku závodní jízdy.</p>\n' +
      '            <p><a class="btn kometa-btn kometa-mladsi-zacky-bg" href="/pridej-se-k-nam">Přidej se k mladším žákům / žačkám</a></p>' +
      "          </div>\n" +
      "        </div>\n" +
      "\n" +
      '        <div class="row">\n' +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <h3 class="h3">Naše úspěchy</h3>\n' +
      '            <p class="text-justify">Poprvé se tento tým účastnil závodu Hevelius Cup v únoru roku 2024 ještě v kategorii nejmladší žáci/žačky se svou jízdou Rio, odkud si odvezl bronzovou medaili.</p>\n' +
      '            <p class="text-justify">Naplno však začal závodit v minulé sezóně 2024/2025, kdy už soutěžil s jízdou na téma tajemná džungle v kategorii mladší žáci/žačky. Stal se vítězem MČR 2025 i českého poháru. A i na dalších domácích a zahraničních soutěžích se těšil z úspěchu.</p>\n' +
      '            <p class="text-justify">Výsledky 2024/2025</p>\n' +
      "            <ul>\n" +
      '            <li class="text-justify">Vysočina Cup 1. místo</li>\n' +
      '            <li class="text-justify">Santa Claus Cup 1. místo</li>\n' +
      '            <li class="text-justify">Amadé Cup 3. místo</li>\n' +
      '            <li class="text-justify">MČR 1. místo</li>\n' +
      '            <li class="text-justify">Budapest Cup 6.místo</li>\n' +
      '            <li class="text-justify">Bakus Cup 1.místo</li>\n' +
      "            </ul>\n" +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/mladsi-zacky/mladsi-zacky-2.jpg" class="img-fluid kometa-image-rounded" alt="Mladší Žačky" />\n' +
      "          </div>\n" +
      "        </div>\n",
    clenky: [
      {
        id: 1,
        jmeno: "Beáta Plešmidová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/beata-plesmidova.jpg",
        od: "2019",
        popis: "",
      },
      {
        id: 2,
        jmeno: "Eliška Bělská",
        obrazek: "/assets/teams/mladsi-zacky/clenky/eliska-belska.jpg",
        od: "2018",
        popis: "",
      },
      {
        id: 3,
        jmeno: "Magdaléna Moudrá",
        obrazek: "/assets/teams/mladsi-zacky/clenky/magdalena-moudra.jpg",
        od: "2019",
        popis: "",
      },
      {
        id: 4,
        jmeno: "Aya Mrkvičková",
        obrazek: "/assets/teams/mladsi-zacky/clenky/aya-mrkvickova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 5,
        jmeno: "Eli Uhliarik",
        obrazek: "/assets/teams/mladsi-zacky/clenky/elli-uhliarik.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 6,
        jmeno: "Kryštov Moudrý",
        obrazek: "/assets/teams/mladsi-zacky/clenky/krystof-moudry.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 7,
        jmeno: "Lilly Exnerová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/lilly-exnerova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 8,
        jmeno: "Magdaléna Valentová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/magdalena-valentova.jpg",
        od: "2019",
        popis: "",
      },
      {
        id: 9,
        jmeno: "Matěj Žáček",
        obrazek: "/assets/teams/mladsi-zacky/clenky/matej-zacek.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 10,
        jmeno: "Mia Ficová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/mia-ficova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 11,
        jmeno: "Nina Marčeková",
        obrazek: "/assets/teams/mladsi-zacky/clenky/nina-marcekova.jpg",
        od: "2024",
        popis: "",
      },
      {
        id: 12,
        jmeno: "Olivie Ornsteinová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/olivie-ornsteinova.jpg",
        od: "2023",
        popis: "",
      },
      {
        id: 13,
        jmeno: "Rozálie Kadlecová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/rozalie-kadlecova.jpg",
        od: "2021",
        popis: "",
      },
      {
        id: 14,
        jmeno: "Tereza Sadílková",
        obrazek: "/assets/teams/mladsi-zacky/clenky/tereza-sadilkova.jpg",
        od: "2022",
        popis: "",
      },
      {
        id: 15,
        jmeno: "Vanda Závorová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/vanda-zavorova.jpg",
        od: "2023",
        popis: "",
      },
      {
        id: 16,
        jmeno: "Veronika Valentová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/veronika-valentova.jpg",
        od: "2019",
        popis: "",
      },
      {
        id: 17,
        jmeno: "Iva Matelová",
        obrazek: "/assets/teams/mladsi-zacky/clenky/iva-matelova.jpg",
        od: "2022",
        popis: "",
      },
    ],
  },
  {
    id: "pripravka",
    barva: "#EDD550",
    jmeno: "Přípravka",
    trener: "Jana Ficová, Kateřina Janovská, Nora Nedvědová",
    komunikace: {
      facebook:
        "https://www.facebook.com/profile.php?id=61555397120486&sk=about",
    },
    obrazekUpoutavky: "/assets/teams/pripravka/team-pripravka-page.jpg",
    obrazekObsahu: "/assets/teams/pripravka/team-pripravka-page.jpg",
    obsah:
      '<div class="row">\n' +
      '          <div class="col-md-5 col-sm-12 mb-4">\n' +
      '            <img src="/assets/teams/pripravka/pripravka-1.jpg" class="img-fluid rounded-5" alt="Přípravka" />\n' +
      "          </div>\n" +
      "\n" +
      '          <div class="col-md-7 col-sm-12 mb-4">\n' +
      '            <p class="text-justify">V přípravce se učíme hravou formou základy bruslení, které se nijak neliší od klasického krasobruslení. Děti si osvojují základní dovednosti jako je stromeček, buřtíky, čáp, vozíček, nebo váha. Později se učí i složitější prvky jako obloučky, přešlapy, trojky apod. Trénink na ledě je doplněn o suchou přípravu, kde se věnujeme protahování, zpevnění středu těla a tréninku koordinace a rovnováhy.</p>\n' +
      '            <p class="text-justify">Do přípravky se mohou připojit děti ve věku 5 - 8 let (začátečníci i mírně pokročilé) průběžně po celou sezónu. Tréninky probíhají dvakrát až třikrát týdně. Přijď si to s námi kdykoli vyzoušet!</p>\n' +
      '            <p><a class="btn kometa-btn kometa-pripravka-bg" href="/pridej-se-k-nam">Přidej se k Přípravce</a></p>' +
      "          </div>\n" +
      "        </div>",
  },
];

export default teams;
